import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';

import {FormBuilder, FormGroup} from '@angular/forms';

import {ActivatedRoute} from '@angular/router';

import {ApiService} from '../../api.service';
import {Message, MessageTypes} from '../../message';
import {MessageService} from '../../message.service';

import {BirthdaysComponent} from '../birthdays.component';
import {TagsComponent} from '../../tags/tags.component';
import {MatDatepicker, MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE} from '@angular/material';
import {isNull} from 'util';

@Component({
    selector: 'app-edit-birthday',
    templateUrl: './edit-birthday.component.html',
    styleUrls: ['./edit-birthday.component.css'],
})
export class EditBirthdayComponent implements OnInit {
    @Output() message = new EventEmitter<Message>();
    @ViewChild(MatDatepicker) datepicker: MatDatepicker<Date>;
    @ViewChild(TagsComponent)
    protected tagsComponent: TagsComponent;

    private id: any;
    public birthday: any;
    private editForm: FormGroup;
    title = 'New birthday';
    state;
    submitLabel: string;

    constructor(
        private route: ActivatedRoute,
        private apiService: ApiService,
        public formBuilder: FormBuilder,
        protected birthdaysComponent: BirthdaysComponent,
        private messageService: MessageService
    ) {
        this.editForm = this.formBuilder.group({
            id: '', /* der Wert '' ist der Default-Wert */
            firstname: '',
            lastname: '',
            birthday: ''
        });
        this.birthday = {id: 0, firstname: '', lastname: '', birthday: new Date(), tags: []};
    }

    ngOnInit() {
        const id = this.route.snapshot.paramMap.get('id');
        this.state = '';
        if (id) {
            this.title = 'Edit birthday';
            this.id = id;
            this.state = 'loading';
            this.submitLabel = 'update';
            this.loadBirthday();
        } else {
            this.submitLabel = 'save';
        }
        // console.log('getting birthday with id', this.id);
    }

    loadBirthday() {
        this.submitLabel = 'loading';
        this.apiService.getById('birthdays', this.id).subscribe(
            (value) => {
                this.birthday = value;
                this.tagsComponent.tags = this.birthday.tags;
                this.state = '';
                this.submitLabel = 'update';
            }, (error) => {
                this.state = '';
                this.submitLabel = 'update';
            }
        );
    }

    submit() {
        this.birthday.tags = this.tagsComponent.tags;
        this.state = 'saving';
        this.submitLabel = 'saving';
        console.log('birthday.birthday:', this.birthday.birthday);
        console.log('this.datepicker', this.datepicker);
        console.log('document.querySelector', document.querySelector('input[name="birthdaypicker"]'));
        if (isNull(this.birthday.birthday)) {
            const inputElement = <HTMLInputElement>document.querySelector('input[name="birthdaypicker"]');
            let dateString = inputElement.value;
            dateString = dateString.split('.').reverse().join('-');
            const theDate = new Date(dateString);
            this.birthday.birthday = theDate;
        }
        if (this.id) {
            this.apiService.put('birthdays', this.id, this.birthday)
                .subscribe(
                    (value: any) => {
                        this.messageService.setMessage('Birthday got updated', MessageTypes.Success);
                        this.state = '';
                        this.submitLabel = 'update';
                    }, (err) => {
                        this.messageService.setMessage('An error occurred - the birthday didn`t get updated', MessageTypes.Error);
                        this.state = '';
                        this.submitLabel = 'update';
                    });
        } else {
            this.apiService.post('birthdays', this.birthday)
                .subscribe(
                    (value: any) => {
                        this.messageService.setMessage('Birthday added', MessageTypes.Success);
                        this.birthdaysComponent.birthdayAdded();
                        this.state = '';
                        this.submitLabel = 'save';
                    }, (err) => {
                        this.messageService.setMessage('Failed to save birthday', MessageTypes.Error);
                        this.state = '';
                        this.submitLabel = 'save';
                    }
                );
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/birthdays/edit-birthday/edit-birthday.component.ts